import {makeStyles} from "@material-ui/core";
import styles from "../../../config/styles";

const style = () => makeStyles({
  bottomNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignCenter: 'center',
    position: 'fixed',
    bottom: '0',
    height: '50px',
    background: '#FFFFFF',
    boxShadow: '0px 0px 4px rgb(0 0 0 / 25%)',
    width: '100%',
    
  },
  bottomNavigationWrapper: {
    flex: '0 80%',
    display: 'flex',
    justifyContent: 'space-around',
    padding: '0.4em 0em',
  },
  bottomLink: {
    display: 'flex',
    flexDirection: 'column'
  },
  linkName: {
    textAlign: 'center',
    color: styles.LIGHT_FONT_COLOR,
    fontFamily: 'Poppins-Regular',
    fontSize:'12px'
  },
  active: {
    color: styles.MAIN_COLOR,
  },
  bottomLinkImg: {
    height: '24px'
  }
})();


export default style;
